// import {
//   Box,
//   FormControlLabel,
//   Grid,
//   MenuItem,
//   Paper,
//   TextField,
//   Typography,
// } from "@mui/material";
// import React, { useState } from "react";
// import Input from "../../../../components/Input";
// import theme from "../../../../theme";
// import ButtonComp from "../../../../components/Button";
// import { useCaseCreationStore } from "../../../../store/useCaseCreationStore";

// export default function BodyLocation({ onNext, onBack }: any) {
//   const [errors, setErrors] = useState<Record<string, string>>({});
//   const { deceasedLocation, setDeceasedLocation } = useCaseCreationStore();

//   const validateForm = () => {
//     const newErrors: Record<string, string> = {};

//     if (!deceasedLocation.houseNumber)
//       newErrors.houseNumber = "House number is required";

//     if (!deceasedLocation.streetName)
//       newErrors.streetName = "Street name is required";

//     if (!deceasedLocation.suburb) newErrors.suburb = "Suburb is required";

//     if (!deceasedLocation.city) newErrors.city = "City is required";

//     if (!deceasedLocation.province) newErrors.province = "Province is required";

//     if (!deceasedLocation.postalCode)
//       newErrors.postalCode = "Postal code is required";

//     if (!deceasedLocation.notes) newErrors.notes = "notes is required";

//     setErrors(newErrors);

//     return Object.keys(newErrors).length === 0;
//   };

//   const handleNextClick = () => {
//     const isValid = validateForm();

//     if (!isValid) return;

//     onNext();
//   };

//   const clearError = (field: string) => {
//     setErrors((prev) => {
//       const updated = { ...prev };
//       delete updated[field];
//       return updated;
//     });
//   };

//   return (
//     <Paper
//       elevation={0}
//       sx={{
//         p: 4,
//         mt: 3,
//         borderRadius: 3,
//         backgroundColor: "#fff",
//       }}
//     >
//       <Grid container spacing={3}>
//         {/* First Name */}
//         <Grid size={{ xs: 12, md: 6 }}>
//           <Input
//             fullWidth
//             label="House / Unit Number*"
//             variant="outlined"
//             value={deceasedLocation.houseNumber}
//             onChange={(e: any) => {
//               setDeceasedLocation({ houseNumber: e.target.value });
//               clearError("houseNumber");
//             }}
//             error={Boolean(errors.houseNumber)}
//             helperText={errors.houseNumber}
//           />
//         </Grid>

//         {/* Last Name */}
//         <Grid size={{ xs: 12, md: 6 }}>
//           <Input
//             fullWidth
//             label="Street Name *"
//             variant="outlined"
//             value={deceasedLocation.streetName}
//             onChange={(e: any) => {
//               setDeceasedLocation({ streetName: e.target.value });
//               clearError("streetName");
//             }}
//             error={Boolean(errors.streetName)}
//             helperText={errors.streetName}
//           />
//         </Grid>

//         {/* Identity Type */}
//         <Grid size={{ xs: 12, md: 6 }}>
//           <Input
//             fullWidth
//             label="Suburb / Area *"
//             variant="outlined"
//             value={deceasedLocation.suburb}
//             onChange={(e: any) => {
//               setDeceasedLocation({ suburb: e.target.value });
//               clearError("suburb");
//             }}
//             error={Boolean(errors.suburb)}
//             helperText={errors.suburb}
//           />
//         </Grid>

//         {/* Identity Number */}
//         <Grid size={{ xs: 12, md: 6 }}>
//           <Input
//             fullWidth
//             label="City / Town *"
//             variant="outlined"
//             value={deceasedLocation.city}
//             onChange={(e: any) => {
//               setDeceasedLocation({ city: e.target.value });
//               clearError("city");
//             }}
//             error={Boolean(errors.city)}
//             helperText={errors.city}
//           />
//         </Grid>

//         {/* Mobile Number */}
//         <Grid size={{ xs: 12, md: 6 }}>
//           <Input
//             fullWidth
//             label="Province *"
//             variant="outlined"
//             value={deceasedLocation.province}
//             onChange={(e: any) => {
//               setDeceasedLocation({ province: e.target.value });
//               clearError("province");
//             }}
//             error={Boolean(errors.province)}
//             helperText={errors.province}
//           />
//         </Grid>
//         <Grid size={{ xs: 12, md: 6 }}>
//           <Input
//             fullWidth
//             label="Postal Code *"
//             variant="outlined"
//             value={deceasedLocation.postalCode}
//             onChange={(e: any) => {
//               setDeceasedLocation({ postalCode: e.target.value });
//               clearError("postalCode");
//             }}
//             error={Boolean(errors.postalCode)}
//             helperText={errors.postalCode}
//           />
//         </Grid>
//         {/* <Grid size={{ xs: 12, md: 6 }}>
//           <Input
//             fullWidth
//             label="Location Type *"
//             variant="outlined"
//             value={deceasedLocation.locationType}
//             onChange={(e: any) => {
//               setDeceasedLocation({ locationType: e.target.value });
//               clearError("locationType")
//             }}
//             error={Boolean(errors.locationType)}
//             helperText={errors.locationType}
//           />
//         </Grid> */}
//         <Grid size={{ xs: 12 }}>
//           <Typography fontSize={18} fontWeight={600} textAlign="left">
//             Notes / Remarks *
//           </Typography>
//           <TextField
//             multiline
//             rows={5}
//             fullWidth
//             variant="outlined"
//             value={deceasedLocation.notes}
//             onChange={(e: any) => {
//               setDeceasedLocation({ notes: e.target.value });
//               clearError("notes");
//             }}
//             error={Boolean(errors.notes)}
//             helperText={errors.notes}
//           />
//         </Grid>
//       </Grid>

//       {/* Buttons */}
//       <Box
//         sx={{
//           display: "flex",
//           justifyContent: "space-between",
//           mt: 5,
//         }}
//       >
//         <ButtonComp variant="outlined" height={40} width={190} onClick={onBack}>
//           Back
//         </ButtonComp>

//         <ButtonComp
//           variant="contained"
//           height={40}
//           width={190}
//           onClick={handleNextClick}
//         >
//           Next
//         </ButtonComp>
//       </Box>
//     </Paper>
//   );
// }

import { useCaseCreationStore } from "../../../../store/useCaseCreationStore";
import BodyLocationForm from "../../components/forms/BodyLocationForm";

export default function BodyLocation({ onNext, onBack, minimalCapture = false }: any) {

   const { deceasedLocation, setDeceasedLocation } = useCaseCreationStore();

  return (
    <BodyLocationForm
      deceasedLocation={deceasedLocation}
      setDeceasedLocation={setDeceasedLocation}
      onNext={onNext}
      onBack={onBack}
      minimalCapture={minimalCapture}
    />
  );
}


